import { getWithTimezone } from '@/utilities/DateHelpers';
import { GameData, GlobalState, InstantWinData, MetricData, ReplacementTags } from '@/store/modules/global/state';
import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store/state';
import { DeviceTypes } from '@/typings/enums/enums';
import { AddonEditItem } from '@/typings/interfaces/data/campaign';
import store from '@/store';
import { format } from 'date-fns';

type GlobalActionContext = ActionContext<GlobalState, RootState>;

export type Actions = {
  setGameData(context: GlobalActionContext, payload: GameData): void;
  setInstantWinData(context: GlobalActionContext, payload: InstantWinData): void;
  setMetricData(context: GlobalActionContext, payload: MetricData): void;
  setReplacementTags(context: GlobalActionContext, payload: ReplacementTags): void;
  setGameWinner(context: GlobalActionContext, payload: boolean): void;
  setGameEnded(context: GlobalActionContext, payload: boolean): void;
  setAddonsData(context: GlobalActionContext, payload: Record<string, AddonEditItem>): void;
  setCurrentDevice(context: GlobalActionContext, payload: DeviceTypes): void;
  addStaticFormData(context: GlobalActionContext, payload: Record<string, string>): void;
  setGameTestDate(context: GlobalActionContext, payload: Date): void;
};

export const actions: ActionTree<GlobalState, RootState> & Actions = {
  setInstantWinData: ({ commit }, payload) => {
    commit('setInstantWinData', payload);
  },

  setMetricData: ({ commit, state }, payload) => {
    commit('setMetricData', {
      ...(state.metricData ?? {}),
      ...payload
    });
  },
  setReplacementTags: ({ commit, state }, payload) => {
    commit('setReplacementTags', {
      ...(state.replacementTags ?? {}),
      ...payload
    });
  },

  setGameData: ({ commit, state }, payload) => {
    commit('setGameData', {
      ...(state.gameData ?? {}),
      ...payload
    });
  },

  setGameWinner: ({ commit }, payload) => {
    commit('setGameWinner', payload);
  },
  setGameEnded: ({ commit }, payload) => {
    commit('setGameEnded', payload);
  },
  setAddonsData: ({ commit }, payload) => {
    commit('setAddonsData', payload);
  },
  setCurrentDevice: ({ commit }, payload) => {
    commit('setCurrentDevice', payload);
  },
  addStaticFormData: ({ commit, state }, payload: Record<string, string>) => {
    const newStaticFormData = {
      ...state.staticFormData,
      ...payload
    };

    commit('setStaticFormData', newStaticFormData);
  },

  addStaticQueryParams: ({ commit, state }, payload: Record<string, string>) => {
    const newStaticQueryParams = {
      ...state.staticQueryParams,
      ...payload
    };

    commit('setStaticQueryParams', newStaticQueryParams);
  },

  setGameTestDate: async ({ commit, dispatch }, payload) => {
    let currentTestDate = payload;

    if (typeof currentTestDate === 'string') {
      currentTestDate = getWithTimezone(`${currentTestDate} 00:00:00`);
    }

    store.commit('global/setGameTestDate', currentTestDate);

    await dispatch('setReplacementTags', { ['date']: format(currentTestDate, 'yyyy-MM-dd') });
    commit('setGameTestDate', currentTestDate);
  }
};
